// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/entity/contact.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/entity/contact.proto.
 */
export const file_proto_model_entity_contact = /*@__PURE__*/
  fileDesc("CiBwcm90by9tb2RlbC9lbnRpdHkvY29udGFjdC5wcm90bxIGY2FybWVuInwKB0FkZHJlc3MSFgoOYWRkcmVzc19saW5lXzEYASABKAkSFgoOYWRkcmVzc19saW5lXzIYAiABKAkSDAoEY2l0eRgDIAEoCRINCgVzdGF0ZRgEIAEoCRITCgtwb3N0YWxfY29kZRgFIAEoCRIPCgdjb3VudHJ5GAYgASgJIiQKBUVtYWlsEg0KBWVtYWlsGAEgASgJEgwKBHR5cGUYAiABKAkiMQoLUGhvbmVOdW1iZXISFAoMcGhvbmVfbnVtYmVyGAEgASgJEgwKBHR5cGUYAiABKAkiFgoHV2Vic2l0ZRILCgN1cmwYASABKAkiRQoLU29jaWFsTWVkaWESJQoEdHlwZRgBIAEoDjIXLmNhcm1lbi5Tb2NpYWxNZWRpYVR5cGUSDwoHYWNjb3VudBgCIAEoCSK7AgoLQ29udGFjdEluZm8SDQoFZW1haWwYASABKAkSKQoMcGhvbmVfbnVtYmVyGAIgASgLMhMuY2FybWVuLlBob25lTnVtYmVyEiAKB2FkZHJlc3MYAyABKAsyDy5jYXJtZW4uQWRkcmVzcxIhChlwcmVmZXJyZWRfY29udGFjdF9tZXRob2RzGAQgAygJEjUKGGFkZGl0aW9uYWxfcGhvbmVfbnVtYmVycxgFIAMoCzITLmNhcm1lbi5QaG9uZU51bWJlchIoChFhZGRpdGlvbmFsX2VtYWlscxgGIAMoCzINLmNhcm1lbi5FbWFpbBIhCgh3ZWJzaXRlcxgHIAMoCzIPLmNhcm1lbi5XZWJzaXRlEikKDHNvY2lhbF9tZWRpYRgIIAMoCzITLmNhcm1lbi5Tb2NpYWxNZWRpYSrKAgoPU29jaWFsTWVkaWFUeXBlEiEKHVNPQ0lBTF9NRURJQV9UWVBFX1VOU1BFQ0lGSUVEEAASHgoaU09DSUFMX01FRElBX1RZUEVfRkFDRUJPT0sQARIdChlTT0NJQUxfTUVESUFfVFlQRV9UV0lUVEVSEAISHwobU09DSUFMX01FRElBX1RZUEVfSU5TVEFHUkFNEAMSHgoaU09DSUFMX01FRElBX1RZUEVfTElOS0VESU4QBBIcChhTT0NJQUxfTUVESUFfVFlQRV9USUtUT0sQBRIdChlTT0NJQUxfTUVESUFfVFlQRV9ZT1VUVUJFEAYSHgoaU09DSUFMX01FRElBX1RZUEVfU05BUENIQVQQBxIeChpTT0NJQUxfTUVESUFfVFlQRV9NQVNUT0RPThAIEhcKE1NPQ0lBTF9NRURJQV9UWVBFX1gQCUIoWiZnaXRodWIuY29tL3l1bmFjYWJhL2Nhcm1lbi9wcm90by9tb2RlbGIGcHJvdG8z");

/**
 * Describes the message carmen.Address.
 * Use `create(AddressSchema)` to create a new message.
 */
export const AddressSchema = /*@__PURE__*/
  messageDesc(file_proto_model_entity_contact, 0);

/**
 * Describes the message carmen.Email.
 * Use `create(EmailSchema)` to create a new message.
 */
export const EmailSchema = /*@__PURE__*/
  messageDesc(file_proto_model_entity_contact, 1);

/**
 * Describes the message carmen.PhoneNumber.
 * Use `create(PhoneNumberSchema)` to create a new message.
 */
export const PhoneNumberSchema = /*@__PURE__*/
  messageDesc(file_proto_model_entity_contact, 2);

/**
 * Describes the message carmen.Website.
 * Use `create(WebsiteSchema)` to create a new message.
 */
export const WebsiteSchema = /*@__PURE__*/
  messageDesc(file_proto_model_entity_contact, 3);

/**
 * Describes the message carmen.SocialMedia.
 * Use `create(SocialMediaSchema)` to create a new message.
 */
export const SocialMediaSchema = /*@__PURE__*/
  messageDesc(file_proto_model_entity_contact, 4);

/**
 * Describes the message carmen.ContactInfo.
 * Use `create(ContactInfoSchema)` to create a new message.
 */
export const ContactInfoSchema = /*@__PURE__*/
  messageDesc(file_proto_model_entity_contact, 5);

/**
 * Describes the enum carmen.SocialMediaType.
 */
export const SocialMediaTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_entity_contact, 0);

/**
 * @generated from enum carmen.SocialMediaType
 */
export const SocialMediaType = /*@__PURE__*/
  tsEnum(SocialMediaTypeSchema);

